import {Injectable} from "@angular/core";
import {PatientService} from "../../../api/services/patient.service";
import {map} from "rxjs/operators";

@Injectable()
export class PatientUploadService{
  constructor(private patientService: PatientService){}

  uploadPatients(patient_list){
    return this.patientService.UploadPatients(patient_list).pipe(map((res)=>{
      return res;
    }));
  }
}
